module.exports = __webpack_public_path__ + "static/media/conlicitaseg.c4eb88bf.svg";